"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportSettingUpdate = reportSettingUpdate;
var _typeof2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/typeof.js"));
var _adminOperationReport = require("@/utils/adminOperationReport");
var _reportContent = require("@/utils/reportContent");
/**
 * 【操作埋点】系统设置模块上报方法
 * 实施时间：2026-05-25
 * 说明：计费/平台/帮助等配置变更，content 支持对象字段展开
 */

function formatSettingValue(value) {
  if (value == null) return '无';
  if ((0, _typeof2.default)(value) === 'object') {
    var text = JSON.stringify(value);
    return text.length > 500 ? text.slice(0, 500) + '…' : text;
  }
  return String(value);
}

/**
 * 更新系统配置埋点上报
 */
function reportSettingUpdate(configKey, configName, oldValue, newValue) {
  var content = (0, _typeof2.default)(newValue) === 'object' && newValue !== null && !Array.isArray(newValue) ? (0, _reportContent.buildReportContent)(newValue, {}, {
    prefix: "\u4FEE\u6539\u914D\u7F6E\u9879\u300C".concat(configName, "\u300D(").concat(configKey, ")"),
    maxLen: 800
  }) : "\u4FEE\u6539\u914D\u7F6E\u9879\u300C".concat(configName, "\u300D(").concat(configKey, ")\uFF0C\u539F\u503C\uFF1A").concat(formatSettingValue(oldValue), "\uFF0C\u65B0\u503C\uFF1A").concat(formatSettingValue(newValue));
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '修改系统配置',
    content: content,
    operation_id: 'pc_setting_update_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_setting_update_1');
}